import { apiClient } from '@/api/apiClient';
import endpoints from './endpoints';

export default {
  getAuthenticated: async (params) => await apiClient.get(endpoints.getAuthenticated(), { params }),
  getHeartbeatAuthorized: async (params) => await apiClient.get(endpoints.getHeartbeatAuthorized(), { params }),
};
